import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const attendanceRequest = {
    /**
     * 考勤查询展示表格
     * */
    findStudentCheckInList(str,page,size) {
        return Fetch({
            url: '/kaoqinweb/checkIn/findStudentCheckInList?'+ str+pageInfo(page,size),
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
     // 进出入宿舍流水
     findStudentInOutList(str,page,size){
        return Fetch({
            url: '/kaoqinweb/inout/findStudentInOutList?'+str+pageInfo(page,size),
            method: 'get'
        });
    },
     /**
     * 未归晚归展示表格
     * */
    findContinuityCheckList(str,page,size) {
        return Fetch({
            url: '/kaoqinweb/checkIn/findContinuityCheckList?'+ str+pageInfo(page,size),
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    /**
     * 根据ID查询校区
     * */
    querySchoolCapmus(id) {
        return Fetch({
            url: '/school/querySchoolCapmus?schoolId='+id,
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    /**
     * 根据ID查询学院
     * */
    querySchoolCollege(id) {
        return Fetch({
            url: '/school/querySchoolCollege?schoolId='+id,
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    /**
     * 根据ID查询校区
     * */
    querySchoolCollege(param) {
        return Fetch({
            url: '/school/querySchoolCollege?'+Qs.stringify(param),
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    querySchoolHouseTree(schoolId) {
        return Fetch({
            url: '/basic/querySchoolHouseTree?schoolId=' + schoolId,
            method: 'get'
        });
    },
    getFloorListByHouseId(id) {
        return Fetch({
            url: '/floor/getFloorListByHouseId?houseId=' + id,
            method: 'get'
        });
    },
    /**
     * 导出考勤统计
     * */
    exportStudentCheckInList(param) {
        return Fetch({
            url: '/exportData/exportStudentCheckInList?' + Qs.stringify(param),
            method: 'get',
            headers: {
                responseType: 'arraybuffer'
            }
        });
    },
 // 根据ID得到学生资料
 getcurrentStudentInfo(studentId){
    return Fetch({
        url: '/accommodationStuIInfo/queryAccommodationStuByUserId?' + studentId,
        method: 'get',
        headers: {
            responseType: 'arraybuffer'
        }
    });
},
// 根据ID查询学生对比照片
findStudentImage(str){
    return Fetch({
        url:'/kaoqinweb/checkIn/findStudentImage?'+str,
        method: 'get'
    });
},
// 根据ID查询学生对比照片
  findStudentInOutImage(str){
    return Fetch({
      url:'/kaoqinweb/inout/findStudentInOutImage?'+str,
      method: 'get'
    });
  },


  // 根据考勤规则查询考勤统计查询时间
  getQueryTime(){
    return Fetch({
      url:'/checkInRule/getQueryTime',
      method: 'get'
    });
  }


}

export default attendanceRequest;



// WEBPACK FOOTER //
// ./src/api/attendanceQuery.js